import dayjs from '../../utilities/dayjs'
import {
  API_ERROR,
  DISPLAY_STATUS,
  PAGE_STATE,
  UNABLE_TO_SIGN_MESSAGE
} from './constants'

export function getGraphQLErrorMessage (error) {
  return error?.response?.errors?.[0]?.message || error?.message || ''
}

export function formatSignedDateTime (value) {
  if (!value) return ''
  return dayjs(value).format('MMMM D, YYYY, h:mm A')
}

export function resolvePageState ({ token, isLoading, isError, agreement }) {
  if (!token) return PAGE_STATE.INVALID
  if (agreement) {
    if (agreement.displayStatus === DISPLAY_STATUS.UNSENT) return PAGE_STATE.INVALID
    if (agreement.displayStatus === DISPLAY_STATUS.LINK_EXPIRED) return PAGE_STATE.LINK_EXPIRED
    if (agreement.displayStatus === DISPLAY_STATUS.SIGNED || agreement.alreadySigned) return PAGE_STATE.SIGNED
    if (agreement.displayStatus === DISPLAY_STATUS.UNSIGNED) return PAGE_STATE.UNSIGNED
    return PAGE_STATE.INVALID
  }
  if (isLoading) return PAGE_STATE.LOADING
  if (isError) return PAGE_STATE.INVALID
  return PAGE_STATE.INVALID
}

export function mapSignError (error) {
  const message = getGraphQLErrorMessage(error)

  if (message.includes(API_ERROR.ALREADY_SIGNED)) {
    return {
      formError: '',
      signedOverride: { displayStatus: DISPLAY_STATUS.SIGNED, alreadySigned: true },
      refetch: true
    }
  }

  if (message.includes(API_ERROR.LINK_EXPIRED)) {
    return {
      formError: '',
      signedOverride: { displayStatus: DISPLAY_STATUS.LINK_EXPIRED, alreadySigned: false }
    }
  }

  if (message.includes(API_ERROR.NOT_AVAILABLE) || message.includes(API_ERROR.NOT_FOUND)) {
    return {
      formError: '',
      signedOverride: { displayStatus: DISPLAY_STATUS.UNSENT }
    }
  }

  if (message.includes(API_ERROR.MUST_ACCEPT)) {
    return { formError: API_ERROR.MUST_ACCEPT }
  }

  if (message.includes(API_ERROR.NAME_REQUIRED)) {
    return { formError: API_ERROR.NAME_REQUIRED }
  }

  return { formError: UNABLE_TO_SIGN_MESSAGE }
}
